module.exports = __webpack_public_path__ + "img/benefit-icon.0363b54f.svg";